<template>
    <b-container fluid>
        <!-- User Interface controls -->

        <div role="tablist">
            <b-card no-body class="mb-1 accordion accordion-style2 accordion-dark">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block href="#" v-b-toggle.accordion-1 variant="primary">Batch Summary</b-button>
                </b-card-header>
                <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <accordion-card :carditems="ft.batchcard"></accordion-card>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block href="#" v-b-toggle.accordion-2 variant="success">Batch Statistics</b-button>
                </b-card-header>
                <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <b-card-text><code><i>Coming Soon....</i></code></b-card-text>
                    </b-card-body>
                </b-collapse>
            </b-card>

            <b-card no-body class="mb-1">
                <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block href="#" v-b-toggle.accordion-3 variant="info">Batch People</b-button>
                </b-card-header>
                <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <div class="row">
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>
                            <div class="col-1">
                                <img src="https://via.placeholder.com/500" height="50px" width="50px" class="rounded-circle" alt />
                            </div>


                        </div>

                    </b-card-body>
                </b-collapse>
            </b-card>
        </div>
        <b-row>
            <b-col md="4" class="my-1 ml-0">

            </b-col>
            <b-col sm="4"></b-col>
            <b-col md="4" class="my-1">
                <b-form-group
                        label="Filter"
                        label-cols-sm="2"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                >
                    <b-input-group size="sm">
                        <b-form-input
                                v-model="filter"
                                type="search"
                                id="filterInput"
                                placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <br>

        <!-- Main table element -->
        <b-table
                show-empty
                small
                striped
                stacked="md"
                :items="trans.filter(trans => trans.nestatus === 'success')"
                :busy="isBusy"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filterIncludedFields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
        >

            <template v-slot:cell(amount)="row">
                {{ row.item.amount | toCurrency }}
            </template>

            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>

        </b-table>

        <b-row>
            <b-col md="3" class="my-1 ml-0">
                <b-form-group
                        label-cols-sm="3"
                        label-cols-md="3"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="perPageSelect"
                        class="mb-0"
                >
                    <b-form-select
                            v-model="perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="pageOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="5"></b-col>
            <b-col sm="4" md="4" class="my-1 mr-0">
                <b-pagination
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        align="fill"
                        size="sm"
                        class="my-0"
                ></b-pagination>
            </b-col>
        </b-row>

        <!-- Info modal -->
        <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
            <pre>{{ infoModal.content }}</pre>
        </b-modal>
    </b-container>
</template>

<script>


    import {mapState} from "vuex";
    import AccordionCard from "../card/AccordionCard";
    export default {
        props:[ 'isBusy', 'accounts', 'trans', 'fields'],
        components: {
            AccordionCard
        },
        data() {
            return {
                'items': [],
                totalRows: 1,
                currentPage: 1,
                perPage: 5,
                pageOptions: [5, 10, 15, 20],
                sortBy: '',
                account: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                },



            }

        },
        computed: {
            ...mapState(['transactions', 'ft']),
            getAccounts() {
                // Create an options list from our fields
                //console.log(this.transactions.balance)
                return this.accounts;
            },

            getStatements(acc){
                return this.account.allActivities.filter(account => account.account === acc)
            }



        },
        mounted() {
                this.items = this.trans
        },
        methods: {
            info(item, index, button) {
                this.infoModal.title = `Row index: ${index}`
                this.infoModal.content = JSON.stringify(item, null, 2)
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            resetInfoModal() {
                this.infoModal.title = '';
                this.infoModal.content = ''
            },
            onFiltered(filteredItems) {
                // Trigger pagination to update the number of buttons/pages due to filtering
                this.totalRows = filteredItems.length;
                this.currentPage = 1
            },
            loadtrans(){
                console.log(this.sortBy);
                console.log(this.items);
                this.items = this.trans.filter(account => account.account === this.sortBy)

            }
        }
    }
</script>
